import { Routes } from '@angular/router';

export const LOGIN_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'agreement',
    loadComponent: () =>
      import('./agreement/agreement.component').then(m => m.AgreementComponent),
  },
  {
    path: 'privacy&policy',
    loadComponent: () =>
      import('./privacypolicy/privacypolicy.component').then(
        m => m.PrivacypolicyComponent,
      ),
  },
];
